import classNames from 'classnames';
import React from 'react';

import useIsLoggedIn from '@jpp/hooks/useIsLoggedIn';
import ContainerLoader from '@jpp/organisms/Loader/ContainerLoader';
import MyAccountTabGroup from '@jpp/organisms/MyAccount/TabGroup';

import './MyAccount.scss';

interface IMyAccountProps {
  className?: string;
}

const ROOT_CLASSNAME = 'MyAccount';

const MyAccount: React.FunctionComponent<IMyAccountProps> = ({ className }) => {
  const isLoggedIn = useIsLoggedIn();

  if (!isLoggedIn) {
    return (
      <div className={classNames(ROOT_CLASSNAME, className)}>
        <div className={`${ROOT_CLASSNAME}__logged-out`}>
          <h2 className={`${ROOT_CLASSNAME}__heading`}>Redirecting you...</h2>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(ROOT_CLASSNAME, className)}>
      <ContainerLoader />
      <MyAccountTabGroup />
    </div>
  );
};

export default MyAccount;
